import { render, staticRenderFns } from "./ConfirmSwitch.vue?vue&type=template&id=29e7c4fe"
import script from "./ConfirmSwitch.vue?vue&type=script&lang=js"
export * from "./ConfirmSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports